"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _card = require("../../../card");
var _button = require("../../../button");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Placeholder = function Placeholder(_ref) {
  var labels = _ref.labels,
    disabled = _ref.disabled,
    createPensionMember = _ref.createPensionMember;
  return /*#__PURE__*/_react["default"].createElement(_card.BuildArea, {
    className: "formula-placeholder"
  }, (0, _utils.split)(labels.PENSION_PENSIONABLE_SALARY_BLOCK_PLACEHOLDER, '%').map(function (item, index) {
    return index % 2 !== 0 ? /*#__PURE__*/_react["default"].createElement(_button.Button, {
      disabled: disabled,
      key: item,
      action: createPensionMember,
      id: "formula-value-button",
      variant: "naked",
      className: "placeholder-cta"
    }, item) : item;
  }));
};
Placeholder.defaultProps = {
  disabled: false
};
Placeholder.propTypes = {
  disabled: _propTypes["default"].bool,
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  createPensionMember: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = Placeholder;